export default "__VITE_ASSET__KHRz5Gyh__"